import { useQuery } from '@tanstack/react-query';
import { useClient } from './useClient';
import {
  GetJobsQuery,
  GetJobsResponse,
} from '@hud/portal-dtos/pr-comparisons.dto';
import { PORTAL_BASE } from '../consts';

export const JOBS_ID = 'jobs';

export default function useJobs(query: GetJobsQuery) {
  const { client, isReady } = useClient();
  return useQuery({
    queryKey: [JOBS_ID, query],
    queryFn: async () => {
      const response = await client.get<GetJobsResponse>(
        `${PORTAL_BASE}/jobs`,
        {
          params: query,
        },
      );
      return GetJobsResponse.parse(response.data);
    },
    enabled: isReady,
  });
}
